export default __webpack_public_path__ + "static/media/guia-2.ae288e71.png";